/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useNavigate } from "react-router-dom";
import { FC, useEffect, useState, SetStateAction, useMemo, useRef } from "react";
import clsx from "clsx";
import { ChefProfile, useAuth } from "../../../auth";
import { ProfileDetails, UpdateProfile } from "../core/_requests";
import { useFormik } from "formik";
import * as Yup from "yup";
import { chefBioSchema } from "../core/Schema";
import ListSettings from "./ListSettings";

type Props = {
  initialValues: any;
};

const BioUpdate: FC<Props> = ({ initialValues }) => {
  const [data, setData] = useState<ChefProfile>(initialValues);
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const chefId =currentUser?.uuid
  const clickCancel = () => {
    navigate("/settings");
  };
  useEffect(() => {
    ProfileDetails(chefId)
      .then((res) => {
        setData(res?.data);   
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);



  const formik = useFormik<ChefProfile>({
    initialValues,
    validationSchema: chefBioSchema,
    onSubmit: async (values, actions) => {
      setLoading(true);
            const updatedData = Object.assign(data, values);
      
      UpdateProfile(updatedData, chefId).then((res) => {
                if (res?.status === true) {
          navigate("/settings/bio-success", { replace: true });
          setLoading(false);
        } else {
          setLoading(false);
        }
      });
    },
  });

  return (
    <>
      <section className="container-fluid">
        <ListSettings/>
        <div className="row">
             
          <section className="content-section">      
            <div className="overlay"></div>
            <div className="drawer small">
              <div className="title row">
                <h3 className="col-10 mb-0">Short Bio</h3>
                <div className="col-2 text-end">
                  <button
                    className="btn p-0 close d-inline-flex"
                    onClick={clickCancel}
                  >
                    <i className="material-symbols-outlined">close</i>
                  </button>
                </div>
              </div>
              <form
                onSubmit={formik.handleSubmit}
                noValidate
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                className="row mt-4 add-bank-form"
              >
                <div className="col-12 mb-3">
                  <label htmlFor="" className="form-label">
                    Tell about yourself & Cooking style
                  </label>
                  <textarea
                    className={clsx(
                      "form-control textarea",
                      {
                        "is-invalid":
                          formik.touched.chefProfile &&
                          formik.errors.chefProfile,
                      },
                      {
                        "is-valid":
                          formik.touched.chefProfile &&
                          !formik.errors.chefProfile,
                      }
                    )}
                    placeholder="Give a short bio..."
                    {...formik.getFieldProps(`chefProfile`)}
                    cols={30} // Change this line
                    rows={10} // Change this line
                  ></textarea>
                </div>
                <div className="col-12 mt-3">
                  <div className="row">
                    <div className="col-4"></div>
                    <div className="col-8 text-end">
                      <button
                        className="btn btn-cancel rounded-5"
                        onClick={clickCancel}
                      >
                        Cancel
                      </button>
                      <button
                        disabled={formik.isSubmitting || !formik.isValid}
                        className="btn btn-outline-primary rounded-5 me-2"
                      >
                        {!loading && (
                          <span className="indicator-label">Publish</span>
                        )}
                        {loading && (
                          <span
                            className="indicator-progress"
                            style={{ display: "block" }}
                          >
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </section>
        </div>
      </section>
    </>
  );
};
export { BioUpdate };
